// src/helpers/knowledgeConfig.js
//
// category/characters/summaries/bookNotes/memories used to live here, each
// pointing at backend-service's legacy /knowledge_api/knowledge/{bookId}/...
// (a second, independent knowledge API operating directly on the Characters/
// BookNotes/Memory/Summaries tables — no CAS versioning, no revision
// tracking, none of what wss-service's KnowledgeFile-based system added).
// Removed: their only consumers (the KnowledgeBase/{Memories,BookNotes,
// Characters,Summaries,Category,KbIcon}.jsx leaf components, useLazyKnowledge,
// knowledgeOperations, and the AiDetectCategory/AiChapterSummary/
// AiUpdateCharacters streaming classes) were unreachable from any live page —
// characters/summaries were still "eager" and fetching on every editor load
// with zero consumers of the result. wss-service's Atlas panel
// (KnowledgeFiles.jsx, useKnowledgeSync.js) is the one live path for all five
// now.

// The registry once drove generic fetch + word-threshold trigger machinery
// (deleted; auto-saves live in useAutoVersioning). knowledgeContext still
// shapes its per-type state slots from it.
export const KB_CONFIG = [{ type: "versions", scope: "chapter", auth: "basic", dataStructure: "list" }];
